import React, { useState, useEffect, useRef } from 'react';
import Sidebar from 'react-sidebar';
import SidebarContents from './sideBarContent';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { connect } from 'react-redux';
import Config from '../../config/Config';
import { setInitialMyStepDetails } from '../../redux/mystep/mystep.actions';
import ErrorModal from '../common/errorModal';
import { setUserType } from '../../redux/userAuthentication/userAuth.actions';
import UserTypes from '../../utils/userTypes';

const SidebarMobile = ({
	fullName,
	setInitialMyStepDetails,
	userPic,
	userType,
	setUserType,
}) => {
	// eslint-disable-next-line no-unused-vars
	const [scroll, setScrollState] = useState(false);
	const [sidebarOpen, onSetSidebarOpen] = useState(false);

	const [name, setName] = useState('');
	const overlayRef = useRef(null);

	useEffect(() => {
		document.getElementById('profileHeader');
		setInitialMyStepDetails();
	}, [setInitialMyStepDetails]);

	// Fix for pointer events when sidebar is opened/closed
	useEffect(() => {
		// Handle overlay pointer events
		const overlay = document.querySelector('[style*="z-index: 4"]');
		if (overlay) {
			overlayRef.current = overlay;

			if (sidebarOpen) {
				// When sidebar is open, ensure overlay captures ALL clicks
				overlay.style.pointerEvents = 'auto';
				// Set a very high z-index on the overlay when open
				overlay.style.zIndex = '99999';

				// Make sure task details doesn't block the overlay
				const taskDetails = document.querySelector('#taskListContainer');
				if (taskDetails) {
					// Store original z-index to restore later
					taskDetails.dataset.originalZIndex = taskDetails.style.zIndex || '';
					taskDetails.style.zIndex = '1';
				}

				// Ensure the page-right-section doesn't block overlay clicks
				const rightSection = document.querySelector('.page-right-section');
				if (rightSection) {
					rightSection.dataset.originalZIndex = rightSection.style.zIndex || '';
					rightSection.style.zIndex = '1';
				}
			} else {
				// When sidebar is closed, disable overlay pointer events
				overlay.style.pointerEvents = 'none';

				// Restore original z-index values
				const taskDetails = document.querySelector('#taskListContainer');
				if (taskDetails && taskDetails.dataset.originalZIndex !== undefined) {
					taskDetails.style.zIndex = taskDetails.dataset.originalZIndex;
				}

				const rightSection = document.querySelector('.page-right-section');
				if (rightSection && rightSection.dataset.originalZIndex !== undefined) {
					rightSection.style.zIndex = rightSection.dataset.originalZIndex;
				}

				// Fix clickable elements when on task page
				if (window.location.pathname.includes('task')) {
					// Set timeout to ensure clickability returns after transition
					setTimeout(() => {
						const actionElements = document.querySelectorAll('.btn, a, .table');
						actionElements.forEach(el => {
							el.style.position = 'relative';
							el.style.zIndex = '10';
							el.style.pointerEvents = 'auto';
						});

						// Specific fix for Go back button
						const goBackButton = document.querySelector('.page-header-product-left a');
						if (goBackButton) {
							goBackButton.style.zIndex = '20';
							goBackButton.style.pointerEvents = 'auto';
						}
					}, 300);
				}
			}
		}
	}, [sidebarOpen]);

	// Create custom overlay click handler
	const onOverlayClick = () => {
		if (sidebarOpen) {
			onSetSidebarOpen(false);
		}
	};

	let details = JSON.parse(localStorage.getItem('userDetails'));

	useEffect(() => {
		setName(details?.full_name || fullName);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [details?.full_name, fullName]);

	return (
		<section>
			<Sidebar
				sidebar={
					<section
						classNames="step-main-nav "
						onClick={() => onSetSidebarOpen(false)}
					>
						<SidebarContents onSetSidebarOpen={onSetSidebarOpen} />
					</section>
				}
				open={sidebarOpen}
				onSetOpen={onSetSidebarOpen}
				onOverlayClick={onOverlayClick}
				styles={{
					sidebar: {
						zIndex: 100000,
						position: 'absolute',
						background: 'white',
						width: '50%',
						top: 0,
						bottom: 0,
						transition: 'transform .3s ease-out',
						WebkitTransition: '-webkit-transform .3s ease-out',
						willChange: 'transform',
						overflowY: 'auto',
					},
					overlay: {
						zIndex: sidebarOpen ? 99999 : 4,
						pointerEvents: sidebarOpen ? 'auto' : 'none',
					},
					content: {
						position: 'relative',
						overflowY: 'auto',
					}
				}}
			>
				<div className="step-def-header" scroll={scroll}>
					<section className="step-container align-stretch container">
						{!window.location.pathname.match(/parent|child/g) && (
							<span onClick={() => onSetSidebarOpen(true)}>
								<FontAwesomeIcon icon={faBars} size="lg" />
							</span>
						)}
						<a href="/mydashboard" className="logoContainer">
							{' '}
							<img
								className="img-responsive logo logo-responsive-mobile"
								src="https://storage.googleapis.com/assets.thehindustep.in/img/STEPElogo.png"
								alt="logo"
							/>{' '}
						</a>
						<div className="page-right-section">
							<div className="dashboard-page">
								<div className="db-body">
									<div id="profileHeader" className="user-header">
										<div className="user-header-dp">
											<a href="/profile">
												<img
													src={
														!!userPic ? userPic : `${Config.ASSETSPATH}/img/Proflie_pic.png`
													}
													href="/profile"
													alt="profile"
												/>
											</a>
										</div>
										<div className="user-header-links">
											<a href="/profile" className="UserNameText">
												Hello, {name}
											</a>
											{userType === UserTypes.Parent && (
												<a
													onClick={() => setUserType(UserTypes.Regular)}
													href="/mydashboard"
												>
													My Dashboard
												</a>
											)}
											<a href="/logout" style={{ cursor: 'pointer' }}>
												<i className="fa fa-sign-out"></i>Logout
											</a>
										</div>
									</div>
								</div>
							</div>
						</div>
					</section>
					<ErrorModal />
				</div>
			</Sidebar>
		</section>
	);
};

const mapStateToProps = (state) => {
	const { userType } = state.rootReducer.loginDetails;
	return {
		fullName: state.rootReducer.userDetails.full_name || state.rootReducer.loginDetails.fullName || state.rootReducer.profileDetails.fullName || state.rootReducer.parentDetails.parentName,
		o_level: state.rootReducer.myStepDetails.score.oLevel,
		userPic: state.rootReducer.loginDetails.userPic,
		userType,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		setInitialMyStepDetails: () => dispatch(setInitialMyStepDetails()),
		setUserType: (type) => dispatch(setUserType(type)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(SidebarMobile);
